<template>
    <div>
        <div class="card-bind">
            <van-nav-bar title="套餐流量订购" @click-left="onClickLeft" left-text="返回" left-arrow></van-nav-bar>
            <div class="page-content">
                <van-tabs v-model="type" title-active-color="red" @click="changeType">
                    <van-tab title="当月套餐">
                        <template slot="title">
                            <span :style="{fontSize:'.3rem',fontWeight:'bolder'}">当月套餐</span>
                        </template>
                    </van-tab>
                    <van-tab title="次月套餐">
                        <template slot="title">
                            <span :style="{fontSize:'.3rem',fontWeight:'bolder'}">次月套餐</span>
                        </template>
                    </van-tab>
                </van-tabs>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <van-row gutter="20" v-if="packageList.length>0">
                            <van-col span="12"  v-for="item in packageList" :key="item.id"  @click="checkPackage(item)">
                                <div class="package-item" :class="packageID==item.id?'active':''">
                                    <span class="title">{{item.title}}</span>
                                    <span class="price">{{item.price}}元</span>
                                </div>
                            </van-col>
                        </van-row>
                        <div v-else style="text-align: center">
                            <div><van-icon name="coupon-o" color="#969696" size="72" /></div>
                            <div style="font-size: 14px;color: #969696">没有可以充值的套餐</div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field package-desc-item" v-if="packageID>0">
                    <div class="md-field-content package-desc" v-html="one.desc" :style="{fontSize:'.3rem'}">

                    </div>
                    <div class="md-field-content package-desc" v-if="type==1" :style="{fontSize:'.3rem',textAlign:'center',color:'#ff2e2e',marginTop:'.3rem'}">
                        您当前充值的是次月套餐，套餐延迟到下个计费周期生效，如果您要马上使用，请充值当月套餐
                    </div>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div @click="createOrder"  class="md-button primary active block" :class="{'active':packageID>0,'inactive':packageID==0}">
                            <div class="md-button-inner">
                                <div class="md-button-content" ><span>立即订购 &gt;&gt;&gt;</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="md-field-content package-desc" v-if="stockInfo.settlementDate>1" :style="{fontSize:'.3rem',textAlign:'center',marginTop:'.3rem'}">
                        您当前的月结日期为每月<span :style="{color:'#ff2e2e'}">{{stockInfo.settlementDate}}号</span>
                    </div>
                </fieldset>

                <!--<div v-else>
                    <van-grid :column-num="2" :style="{paddingTop:'1rem'}" :gutter="20" :square="true" :icon-size="56">
                        <van-grid-item icon="arrow-left" @click="type=0;queryPackageList()" :style="{color:'#32dac5'}" text="充当月套餐" />
                        <van-grid-item icon="arrow"  @click="type=1;queryPackageList()" :style="{color:'#8555f5'}" text="充次月套餐" />
                    </van-grid>
                </div>-->
            </div>
        </div>
        <div  class="warm-tips" v-if="tips.length>0">
            <h5 >温馨提示</h5>
            <ol>
                <li v-for="(tip,index) in tips" :key="index" v-text="tip"></li>
            </ol>
        </div>
    </div>
</template>

<script>
    export default {
        name: "recharge",
        data() {
            return {
                iccid:'',
                packageID:0,
                type:0,
                packageList:[],
                one:{},
                stockInfo:{},
                tips:[]
            };
        },
        watch:{
            type:function () {
                this.one = {}
                this.queryPackageList();
            }
        },
        methods: {
            queryPackageList(){
                this.$toast.loading()
                this.fetchData('/package/getRechargePackage',{iccid:this.iccid,type:this.type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.packageList = res.data
                    }else{
                        this.$toast.fail(res.msg)
                        this.packageList=[]
                    }
                })
            },
            checkPackage(item){
                this.packageID = item.id
                this.one = item;
            },
            changeType(type){
                this.type = type;
                this.queryPackageList();
            },
            createOrder(){
                this.$toast.loading()
                this.fetchDataPost('/order/createOrder',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', res.data,
                        (res)=>{
                            if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                                this.$toast.success('支付成功');
                                this.$route.push({name:'index'})
                            }
                        }
                    );
                    }else{

                        if(res.url){
                            this.$dialog.confirm({
                                title: '提示',
                                message: res.msg
                            }).then(() => {
                                // on confirm
                                let query = {}
                                if(res.data){
                                    query = res.data
                                }
                                query.cardno = this.iccid
                                this.$router.push({path:res.url,query:query})
                            }).catch(() => {
                                // on cancel
                            });
                        }

                        if(res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1){
                            this.$toast.fail('登录失效，请尝试重新进入查询')
                            sessionStorage.clear()
                        }else {
                            this.$toast.fail(res.msg)
                        }
                    }
                })
            },
            getStockInfo(){
                this.fetchData('/card/info',{iccid:this.iccid},(res)=>{
                    this.stockInfo = res.data
                })
            },
            getTips(){
                this.fetchData('/card/tips',{iccid:this.iccid},(res)=>{
                    this.tips = res.data.split("\n")
                })
            }
        },
        created: function () {
            let query = this.$route.query;
            this.iccid = query.iccid;
            this.getStockInfo()
            this.queryPackageList()
            this.getTips()
        }
    };
</script>
<style>

    .van-col{
        margin-bottom: .2rem;
    }
    .package-item span{
        display: block;
        text-align: center;
        letter-spacing: .05rem;
        color: #75b2f9;
        font-size: .3rem;
        line-height: .34rem;
        font-weight: bold;
    }

    .page-title {
        margin: .3rem 0 0 0;
        font-size: .3rem;
        height: .8rem;
        line-height: .8rem;
        border-radius: .2rem .2rem 0 0;
        border-bottom: 1px solid #fafafa;
        color: #888;
        text-align: center;
    }

    .package-item.active span{
        color: #fff;
    }

    .package-item span.price{
        width: 1.5rem;
        line-height: .2rem;
        margin: .2rem auto;
        border-radius: .2rem;
        padding: .1rem;
        color: #fff;
        letter-spacing: .01rem;
        background: -webkit-gradient(linear, right top, left top, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(180deg, #3c6bff, #75b2f9);
    }

    .package-item.active span.price{
        background: #fff;
        color: #75b2f9;
    }


    .page-content {
        padding-bottom: .1rem;
        min-height: 6rem;
        border-radius: 0 0 .2rem .2rem;
        background: #fff;
    }

    .md-button {
        display: block;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.36rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        text-align: center;
        box-sizing: border-box;
        -webkit-appearance: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0.04rem;
        outline: 0px;
        transition: all 0.3s ease 0s;
        overflow: visible;
    }

    .md-button {
        position: relative;
    }

    .md-button.primary {
        background: #2f86f6;
        color: #fff;
    }

    .md-button.block {
        width: 100%;
    }

    .md-button.inactive {
        opacity: .3;
    }

    .md-button-inner {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        word-wrap: break-word;
        white-space: nowrap;
    }

    .package-desc-item{
        padding: 0 .4rem;
    }
    .package-desc{
        font-size: .16rem;
        overflow: hidden;
        word-wrap: break-word;
        text-align: left;
    }
    .package-item{
        padding: .2rem .1rem .1rem .1rem;
        border: 1px solid #75b2f9;
        border-radius: 5px;
    }
    .package-item.active{
        background: -webkit-gradient(linear, right top, left top, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(180deg, #3c6bff, #75b2f9);
    }
    .md-field {
        padding: .1rem .2rem;
        border: none;
    }

</style>



// WEBPACK FOOTER //
// src/pages/recharge.vue